<template>
    <div :class="['d-flex cursor-pointer justify-content-center mt-2 rounded']">
        <v-text-field @click="goToTransactions"
                      class="centered-input cursor-pointer readonly priceWallet menu-text mx-0 px-0 py-0 my-0 mt-0 pt-0 rounded"
                      v-b-tooltip.hover="'لیست تراکنش های شما'" :value="balance|currency|persianNum "
                      full-width readonly prepend-inner-icon="اعتبار" append-icon="mdi-currency-rial">
        </v-text-field>
        <v-btn color="blue" class="priceWalletButton px-0 my-0 mx-0" @click="$store.dispatch('wallet/toggleOpen')"
               style=" background-color: #6cdb72!important;">
            <v-icon class="plus" small>
                mdi-plus
            </v-icon>
        </v-btn>
    </div>
</template>

<script>
const exhale = ms =>
    new Promise(resolve => setTimeout(resolve, ms))

export default {
    name: "WalletOpenButton",
    data: () => ({
        checking: false,
        heartbeats: [],
    }),
    props: {
        hideInMobile: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        let classes = window.document.querySelectorAll(".priceWallet .v-input__control .v-text-field__slot *");
        for (let c of classes) {
            c.classList.add('on-scroll-shoed');
        }

    },
    computed: {
        avg() {
            const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0)
            const length = this.heartbeats.length

            if (!sum && !length) return 0

            return Math.ceil(sum / length)
        },

        balance() {

            // let balance = this.$store.getters['wallet/wallet'];
            let balance = JSON.parse(localStorage.getItem('user_wallet'));
            return balance ? balance.balance : "";
        }
    },

    created() {
        this.takePulse(false)
    },

    methods: {
        heartbeat() {
            return Math.ceil(Math.random() * (120 - 80) + 80)
        },
        goToTransactions() {
            window.open('https://core.terminalads.com/#/user/transactions')
        },
        async takePulse(inhale = true) {
            this.checking = true

            inhale && await exhale(1000)

            this.heartbeats = Array.from({length: 20}, this.heartbeat)

            this.checking = false
        },

        convertToHumanReadablePrice(input) {
            return (input ? input.toString() : "0").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },

    },
}
</script>

<style scoped>
.backButton {
    margin-top: -1rem;
    margin-right: -1.2rem;
}

.titleWallet {
    margin-top: -0.52rem;
    margin-left: 2rem;
}

.centered-input >>> input {
    text-align: center;
}

.priceWallet {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    /*border-bottom-right-radius: 0%;
    border-top-right-radius: 0%;*/
}

.priceWalletButton {
    box-shadow: none;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 20%;
    border-top-left-radius: 20%;
    /*border-radius: 15%;*/


    min-width: 2.5rem !important;
    height: 2.5rem !important;
    background-color: #4ba5de !important;
    color: white
    /*color: white;*/

}
</style>
<style>
@media only screen and (max-width: 990px) {
    .priceWallet .v-input__control {
        width: auto !important;
    }

    .priceWallet {
        margin-top: -.5rem !important;
        margin-right: 2rem !important;
    }

    .priceWallet + * {
        margin-top: -.5rem !important;
        margin-left: 1rem !important;
    }

    .hiddenInMobileH {
        display: none !important;
    }
}

.priceWallet .v-input__control {
    min-width: 20px;
    min-height: 2.5rem !important;
    height: 2.5rem !important;
    background-color: rgba(256, 256, 256, 0.2) !important;
    color: white;
    /*background-color: hsla(0, 0%, 100%, 0.12) !important;*/
    width: 12vw;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}

.priceWallet .v-input__control .v-input__slot * {
    padding: 0 0.5rem;
    min-height: 2.5rem !important;
    height: 2.5rem !important;
    font-size: 1.2rem;
    font-weight: bold;
    cursor: pointer !important;
    color: white;
    font-family: 'vazir';
}

body[data-scrolltop='on'] .priceWallet .v-input__control .v-input__slot * {
    color: rgba(128, 132, 155, 0.93);
    cursor: pointer !important;
}

.priceWallet .v-input__control .v-input__slot {
    padding: 0 0.5rem;
    min-height: 2.5rem !important;
    height: 0rem !important;
    font-size: 1rem;
    cursor: pointer !important;
    margin: 0;
}

.priceWallet .v-input__control .v-input__slot:before {
    border-style: none
}

.priceWallet .v-input__control .v-input__slot:after {
    border-style: none;
    cursor: pointer !important;
}

.priceWallet .v-input__control .v-input__prepend-inner {
    padding-left: 0;
    cursor: pointer !important;

}

.priceWallet .v-input__control .v-input__prepend-inner .append-icon {
    padding: 0;
    cursor: pointer !important;
}

.priceWallet .append-icon {
    background-color: white;
    -webkit-mask: url('/etebar.png') no-repeat center;
    mask: url('/etebar.png') no-repeat center;
    mask-size: 35px 20px;
    cursor: pointer !important;
    width: 45px;
    height: 20px !important;
}


body[data-scrolltop='on'] .priceWallet .append-icon {
    background-color: rgba(128, 132, 155, 0.93);
    cursor: pointer !important;
}


.priceWallet .v-input__control .v-input__prepend-inner {
    margin-top: 0 !important;
    cursor: pointer !important;
}

.priceWallet .v-input__control .v-text-field__slot {
    font-size: 1rem;
    align-items: center;
    margin: 0;
    cursor: pointer !important;
    padding: 0;
}

.priceWallet .v-input__control .v-text-field__slot .v-text-field__prefix {
    margin-top: 0.3rem;
    cursor: pointer !important;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner {
    margin: 0 !important;
    padding: 0 !important;
    cursor: pointer !important;
    font-size: 1.6rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 1.6rem;
    cursor: pointer !important;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append .v-icon {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 1.6rem;
    cursor: pointer !important;

}

body[data-scrolltop='on'] .on-scroll-shoed {
    color: rgb(126, 130, 153) !important;
    font-weight: normal !important;
}

body[data-scrolltop='on'] .priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append .v-icon {
    color: rgb(126, 130, 153);
}

body[data-scrolltop='on'] .priceWalletButton {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #6cdb72 !important;
}

body[data-scrolltop='on'] #kt_header > div.d-flex.align-items-center.justify-content-between.container > div.topbar > div.d-flex.justify-content-ceter.mt-2.rounded > div > div {
    /*border: 2px solid dodgerblue;*/
    background-color: rgba(128, 128, 128, 0.15) !important;


}
</style>
